import Notification from "@/services/echo-manager/notification";
import {useMainStore} from "@/store";

export default class PurchasingPasscodeRemoved extends Notification
{
    handle() {
        useMainStore().SET_PASSCODE(false);
    }
}